import { getMovingCenterDataState } from '../';
import { actions, selectors } from '../../../../state';
import template from './move-kind-toggle.html';
import './move-kind-toggle.global.css';

class MoveKindToggleController {
  constructor(updStore, MovingCenterActions) {
    'ngInject';
    Object.assign(this, {
      updStore,
      MovingCenterActions,
    });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis.bind(this))(this);
  }

  $onDestroy() {
    this.disconnect();
  }

  toggleMoveKind() {
    const { dispatch } = this.updStore;
    this.toggling = true;

    dispatch(
      this.MovingCenterActions.updateMoveKind(
        this.isPremium ? 'diy' : 'premium',
        this.moveId
      )
    )
      .then(
        () =>
          dispatch(
            actions.router.stateGo(getMovingCenterDataState(this.isPremium))
          ),
        () =>
          dispatch(
            actions.message.error(
              'We were unable to process your request at the moment.'
            )
          )
      )
      .finally(() => (this.toggling = false));
  }
}

function mapStateToThis(state) {
  return {
    isPremium: selectors.movingCenter.isPremiumKind(this.moveId, state),
  };
}

export const MoveKindToggleComponent = {
  template,
  controller: MoveKindToggleController,
  bindings: {
    moveId: '<',
    prefaceText: '@',
    ctaText: '@',
    ctaAnalyticsEvent: '@',
    // Crutch until we can use redux actions to determine when something is loading.
    toggling: '=',
  },
};
